import { NOT_SET } from '@utils/tracking/constants';
import { track, logError } from '@tracking';
import getMenu from '@core/reducers/menu/selectors/getMenu';
import { getSection } from '@core/reducers/menu/selectors/getMenuSection';
import getShopId from '@core/reducers/shop/selectors/getShopId';

const trackProductSearchClicked = ({ sectionId } = {}) => (
  dispatch,
  getState,
) => {
  const EVENT_NAME = 'product_search.clicked';

  try {
    const state = getState();
    const menu = getMenu(state);
    const section = sectionId ? getSection(state, sectionId) : null;

    const shopId = getShopId(state);
    const menuSection = section ? 'section_details' : 'menu';
    const shopItemsQuantity = section
      ? section.totalProducts
      : menu?.sections?.reduce(
          (sum, currentSection) => sum + currentSection.totalProducts,
          0,
        ) || NOT_SET;

    const productCategory = section ? section.name : NOT_SET;
    const productCategoryIndex =
      section && menu?.sections
        ? menu.sections.findIndex(x => x.id === section.id)
        : NOT_SET;

    const payload = {
      shopId,
      menuSection,
      shopItemsQuantity,
      productCategory,
      productCategoryIndex,
    };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackProductSearchClicked;
